import { Dispatch, SetStateAction } from 'react';
import { SEOSegmentationFilterInput } from '@/__generated__/globalTypes';
import { PayRate } from '../../PayRate';
import { CanHelpWith } from './CanHelpWith';

interface HomeCareFiltersProps {
  hourlyRate: [number, number];
  setHourlyRate: Dispatch<SetStateAction<[number, number]>>;
  housekeepingSubServices: SEOSegmentationFilterInput['housekeepingSubServices'];
  setHousekeepingSubServices: Dispatch<
    SetStateAction<SEOSegmentationFilterInput['housekeepingSubServices']>
  >;
}

const HomeCareFilters = ({
  hourlyRate,
  setHourlyRate,
  housekeepingSubServices,
  setHousekeepingSubServices,
}: HomeCareFiltersProps) => {
  return (
    <>
      <PayRate hourlyRate={hourlyRate} setHourlyRate={setHourlyRate} />
      <CanHelpWith
        canHelpWithServices={housekeepingSubServices}
        setCanHelpWithServices={setHousekeepingSubServices}
      />
    </>
  );
};

export { HomeCareFilters };
